import { TransferStatusCounts } from "@/api/insight";
import { AcceptanceStatus } from "@/pages/CareInsight/types";
import { create } from "zustand";

interface TransferStatusCountsState {
  transferStatusCounts: Record<AcceptanceStatus, number>;
  settransferStatusCounts: (
    transferStatusCounts: Record<AcceptanceStatus, number>
  ) => void;
}

export const useTransferCountsStore = create<TransferStatusCountsState>(
  (set) => ({
    transferStatusCounts: {
      in_progress: 0,
      accepted: 0,
      rejected: 0,
      canceled: 0,
      transfer_confirmed: 0,
      transfer_completed: 0,
    },
    settransferStatusCounts: (transferStatusCounts) =>
      set({ transferStatusCounts }),
  })
);

// import { TransferStatusCounts } from "@/api/insight";
// import { create } from "zustand";

// interface TransferStatusCountsState {
//   transferStatusCounts: TransferStatusCounts;
//   settransferStatusCounts: (transferStatusCounts: TransferStatusCounts) => void;
// }

// export const useTransferCountsStore = create<TransferStatusCountsState>(
//   (set) => ({
//     transferStatusCounts: {
//       noResponse: 0,
//       accepted: 0,
//       rejected: 0,
//       canceled: 0,
//       transferring: 0,
//       completed: 0,
//     },
//     settransferStatusCounts: (transferStatusCounts) =>
//       set({ transferStatusCounts }),
//   })
// );
